import { computed, defineComponent, reactive } from 'vue';
import moment from 'moment';
import { useModelWrapper, DateHelper } from '@hems/util';
import MonthPicker from './MonthPicker.vue';
export default defineComponent({
    name: 'VCalendarMonth',
    components: {
        MonthPicker,
    },
    inheritAttrs: false,
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
        format: {
            type: String,
            default: null,
        },
        langCd: {
            type: String,
            default: 'en',
        },
    },
    setup(props, { emit }) {
        const state = reactive({
            open: false,
            value: useModelWrapper(props, emit),
            type: 'start',
        });
        const displayValueStart = computed(() => props.format
            ? moment(state.value.start).format(props.format)
            : DateHelper.getDateFormatter(props.langCd, {
                year: 'numeric',
                month: 'numeric',
            })
                .format(state.value.start)
                .toString());
        const displayValueEnd = computed(() => props.format
            ? moment(state.value.end).format(props.format)
            : DateHelper.getDateFormatter(props.langCd, {
                year: 'numeric',
                month: 'numeric',
            })
                .format(state.value.end)
                .toString());
        return {
            state,
            displayValueStart,
            displayValueEnd,
            onOpen: (direct) => {
                state.type = direct;
                state.open = true;
            },
            onClose: () => {
                state.open = false;
            },
        };
    },
});
